import { BookOpen, ClipboardList, ListChecks, ListOrdered, PanelsTopLeft, Settings, UserRound } from "lucide-react";

export const retailNavList = [
  {
    id: 1,
    heading: "",
    children: [
      {
        id: 1,
        title: "profile",
        icon: <UserRound size={20} />,
        link: "/profile"
      },
      {
        id: 2,
        title: "account",
        icon: <Settings size={20} />,
        link: "/profile/account"
      }
    ]
  },
  {
    id: 2,
    heading: "orders",
    children: [
      {
        id: 1,
        title: "my orders",
        icon: <ListOrdered size={20} />,
        link: "/profile/myorders"
      }
    ]
  },
  {
    id: 3,
    heading: "my lists",
    children: [
      {
        id: 1,
        title: "wishlist",
        icon: <ListChecks size={20} />,
        link: "/profile/wishlist"
      },
      {
        id: 2,
        title: "recommendations",
        icon: <PanelsTopLeft size={20} />,
        link: "/profile/wishlist"
      }
    ]
  }
];

export const educationNavList = [
  {
    id: 1,
    heading: "Profile",
    children: [
      {
        id: 1,
        title: "profile",
        icon: <UserRound size={20} />,
        link: "/profile"
      },
      {
        id: 2,
        title: "my enrollments",
        icon: <ListOrdered size={20} />,
        link: "/profile/myorders"
      },
      {
        id: 3,
        title: "my courses",
        icon: <BookOpen size={20} />,
        link: "/myCourses"
      }
    ]
  }
];

export const institutionNavList = [
  {
    id: 1,
    heading: "Applications & Invoices",
    children: [
      {
        id: 1,
        title: "my applications",
        icon: <ClipboardList size={20} />,
        link: "/my-application"
      },
      {
        id: 2,
        title: "invoice",
        icon: <ClipboardList size={20} />,
        link: "/invoice"
      }
    ]
  }
];
